import React from 'react';

export function KanbanBoard({ children, className = '' }) {
  return <div className={`today-kanban ${className}`.trim()}>{children}</div>;
}

export function KanbanStack({ title, sub, meta, children }) {
  return (
    <div className="kanban-stack">
      <div className="kanban-stack-head">
        <div>
          <div className="kanban-stack-title">{title}</div>
          {sub ? <div className="kanban-mini">{sub}</div> : null}
        </div>
        {meta ? <div className="td-mono" style={{ fontWeight: 800 }}>{meta}</div> : null}
      </div>
      <div className="today-kanban-scroll">
        {children}
      </div>
    </div>
  );
}
